<template>
  <div id="seedModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="seedModalLabel1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="exampleModalLabel1" class="modal-title">
            Add New Seed
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body card-blue">
          <form class="form-horizontal" @submit.prevent="handleSubmit">
            <div class="card-body">
              <div class="form-group row">
                <label for="crop" class="col-sm-3 text-right control-label col-form-label">Crop</label>
                <div class="col-sm-9">
                  <multiselect id="crop" v-model="seed.crop" v-validate="'required'" name="crop" :options="cropList" class="form-control" label="name" track-by="name" placeholder="Select a crop" data-vv-as="Crop" :class="{'is-invalid': submitted && errors.has('crop')}" />
                  <div v-if="submitted && errors.has('crop')" class="invalid-feedback">
                    {{ errors.first('crop') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="amount" class="col-sm-3 text-right control-label col-form-label">Amount</label>
                <div class="col-sm-9">
                  <div class="input-group">
                    <input id="amount" v-model="seed.amount" v-validate="'required'" type="text" class="form-control" name="amount" placeholder="Amount" data-vv-as="Amount" :class="{'is-invalid': submitted && (errors.has('amount') || errors.has('units'))}">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{ seed.amount_units }}
                      </button>
                      <div class="dropdown-menu" x-placement="bottom-start">
                        <a v-for="(unit,index) in unitList" :key="index" class="dropdown-item" @click="setAmountUnits(unit.value)">{{ unit.text }}</a>
                      </div>
                    </div>
                    <div v-if="submitted && errors.has('amount')" class="invalid-feedback">
                      {{ errors.first('amount') }}
                    </div>
                    <div v-if="submitted && errors.has('amount_units')" class="invalid-feedback">
                      {{ errors.first('amount_units') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="price_amount" class="col-sm-3 text-right control-label col-form-label">Price (USD)</label>
                <div class="col-sm-9">
                  <input id="price_amount" v-model="seed.price_amount" v-validate="'required'" type="text" class="form-control" name="price_amount" placeholder="Price" data-vv-as="Price" :class="{'is-invalid': submitted && errors.has('price_amount')}">
                  <div v-if="submitted && errors.has('price_amount')" class="invalid-feedback">
                    {{ errors.first('price_amount') }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="price_amount" class="col-sm-3 text-right control-label col-form-label">Year</label>
                <div class="col-sm-9">
                  <select id="year" v-model="year" class="form-control" name="year">
                    <option v-for="(year,index) in yearList" :key="index" :value="year">
                      {{ year }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn waves-effect waves-light btn-success" @ok="save()">
                Save
              </button>
              <button type="button" class="btn waves-effect waves-light btn-secondary" @click="reset()">
                Reset
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'

export default {
  name: 'SeedModal',
  components: { Multiselect },
  props: ['propYear'],
  data () {
    return {
      submitted: false,
      seed: {
        amount: '',
        amount_units: 'Select Unit',
        crop: '',
        price_amount: '',
        price_units: 'USD',
        type: ''
      },
      yearList: [],
      year: (new Date()).getFullYear(),
      cropList: [],
      unitList: [
        { value: 'EA', text: 'Each' },
        { value: 'BU', text: 'Bushels' },
        { value: 'KG', text: 'Kilograms' },
        { value: 'T', text: 'Tons' },
        { value: 'LBS', text: 'Pounds' },
        { value: 'MT', text: 'Metric Tons' },
        { value: 'L', text: 'Liters' },
        { value: 'ml', text: 'milli liters' }
      ]
    }
  },
  mounted () {
    this.getCropList()
    if (this.propYear !== undefined) {
      this.year = this.propYear
    }
    const currentYear = (new Date()).getFullYear()
    this.yearList = []
    for (var i = 0; i < 5; i++) {
      this.yearList.push(parseInt(currentYear) + i)
    }
  },
  methods: {
    setAmountUnits (amount_units) {
      this.seed.amount_units = amount_units
    },
    handleSubmit () {
      this.submitted = true
      this.$validator.validate()
        .then(valid => {
          if (valid) {
            this.save()
          }
        })
    },
    async save () {
      console.log(this.seed)
      await this.$api.put('/growers/inputs/seed', this.seed, {
        params: {
          year: this.year
        }
      })
      this.$toastr('success', 'New seed added successfully.', 'Seed Saved')
      this.$parent.year = this.year
      this.$parent.getInputList()
      this.reset()
      $('#seedModal').modal('toggle')
    },
    reset () {
      this.submitted = false
      this.seed = {
        amount: '',
        amount_units: 'Select Unit',
        crop: '',
        price_amount: '',
        price_units: 'USD'
      }
    },
    async getCropList () {
      const reply = await this.$api.get('/fields/crops', {})
      this.cropList = reply.data
    }
  }
}
</script>

<style scoped>
</style>
